import { GridColumn as Column } from '@progress/kendo-react-grid';
import { SystemGrid } from 'library';
import * as React from 'react';



const SystemLanguageGrid= (props: any) => {

    //const str = window.location.search;
    //const LookupIdEncrypted = str.split('=').pop();

    const url = '/Common/GridByLanguage/' + localStorage.getItem("LableName") || '';
    console.log(props)
    return <SystemGrid dataSource={url} height="auto" pageSize={10} pageable={true} onRowClick={props.onRowClick} refresh={props.refresh}  >

       
        <Column key={1} width="auto" field="EnglishText" title="EnglishText" />
        <Column key={2} width="auto" field="Language" title="Language" />
        <Column key={3} width="auto" field="TranslatedText" title="TranslatedText" />


    </SystemGrid>
}

export default SystemLanguageGrid